var $searchIcon = $('header .main-nav .nav-menu #search-icon');
var $headerSearchInput = $('header #header-search #header-search-input');
var $text = $('body.search #content-section .content-wrapper .search-result a .post-info p');
var $searchPage = $('body.search');
var $pageSearchInput = $('#content-section #search #search-input');
var $inputValue = $pageSearchInput.val();

if ($searchIcon) {
    $searchIcon.click(function () {
        var $form = $(this).parent('.nav-menu').children('#header-search');
        var expanded = $form.toggleClass('expand').hasClass('expand');
        $(this).attr('aria-expanded', expanded ? 'true' : 'false');
        // inert must be lifted before focus(), or the focus call is a no-op
        if (expanded) {
            $form.removeAttr('inert');
            $form.find('#header-search-input').focus();
        } else {
            $form.attr('inert', 'inert');
        }
    });
}

$headerSearchInput.on('input', function () {
    if ($(this).val() != '') {
        $(this).parent('#header-search').children('button').addClass('show');
    } else {
        $(this).parent('#header-search').children('button').removeClass('show');
    }
});

function highlight(query, $text) {
    var rgxp = new RegExp(query, 'gi');
    var repl = '<span class="highlight">' + query + '</span>';
    $text.each(function (index, element) {
        $(this).html($(this).html().replace(rgxp, repl));
    });
}

if ($searchPage.length) {
    if ($inputValue) {
        highlight($inputValue, $text);
    }
    // clear-then-reset puts the caret at the end of the existing query
    $pageSearchInput.focus();
    $pageSearchInput.val('');
    $pageSearchInput.val($inputValue);
}
